import http from '../utils/http'
import joinUrls from '../utils/join-urls'

export default {
	getClan(id) {
		return http.get(joinUrls('/clans', id));
	}
}